import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { isWatchingCompleted } from '@/shared/lib/watching';

import { isPlayingFromBeginningVar } from '../../movie-player/utils/is-playing-from-beginning-var';
import { getTimingsInterval } from '../../player-config/helpers/get-timings-interval';

interface VideoPlaybackState {
    currentTime: number;
    duration: number;
    skippableFragments: SkippableFragment[];
}

export function getMovieStartPosition(videoState: VideoPlaybackState) {
    const { currentTime, duration, skippableFragments } = videoState;

    const watchingIsFinished = isWatchingCompleted({
        currentTime,
        duration,
        skippableFragments,
        toleranceMs: getTimingsInterval(),
    });
    const isPlayFromBeginning = isPlayingFromBeginningVar.get() || !currentTime;

    return watchingIsFinished || isPlayFromBeginning ? 0 : currentTime;
}
